export enum PAY_STATUS {
	PAID = 'Paid',
	PENDING = 'Pending',
}

export enum REPORTS_GET_FILE {
	UNPAID_ITEMS = 'Unpaid items',
	UNPAID_TABLES = 'Unpaid tables',
	PARTICIPANTS = 'Participants',
	MAX_BIDS = 'Value of max bids',
	FULL_REPORT = 'Full report',
}
